import { FINISHED, OPEN } from '@/static/protocol/protocolProcessingStatus';
import wareneingangspruefungStatus from '@/static/wareneingangspruefung/wareneingangspruefungStatus';
import {
  finishedAt, finishedFrom, warenannahme, reason, pruefungStatus,
} from '@/config/wareneingangspruefung/wareneingangspruefungFields';

export default [
  {
    path: 'wareneingangspruefung',
    component: () => import('@/layouts/wareneingangspruefung/Wareneingangspruefung.vue'),
    children: [
      {
        name: 'wareneingangspruefung',
        path: '',
        component: () => import('@/views/wareneingangspruefung/WareneingangspruefungStartseite.vue'),
      },
      {
        name: 'wareneingangspruefung.liste',
        path: 'liste',
        component: () => import('@/views/wareneingangspruefung/WareneingangspruefungListe.vue'),
        props: {
          title: 'Wareneingangsprüfungen',
        },
      },
      {
        name: 'wareneingangspruefung.liste.aktuell',
        path: 'liste/aktuell',
        component: () => import('@/views/wareneingangspruefung/WareneingangspruefungListe.vue'),
        props: {
          title: 'Aktuelle Wareneingangsprüfungen',
          additionalFields: [
            pruefungStatus,
          ],
          status: OPEN,
        },
      },
      {
        name: 'wareneingangspruefung.liste.abgeschlossen',
        path: 'liste/abgeschlossen',
        component: () => import('@/views/wareneingangspruefung/WareneingangspruefungListe.vue'),
        props: {
          title: 'Abgeschlossene Wareneingangsprüfungen',
          status: FINISHED,
          additionalFields: [
            finishedAt,
            finishedFrom,
            pruefungStatus,
            warenannahme,
            reason,
          ],
          showWarenannehmeFilter: true,
        },
      },
      {
        path: 'wareneingang',
        name: 'wareneingangspruefung.wareneingang.liste',
        component: () => import('@/views/wareneingangspruefung/WareneingangListe.vue'),
      },
      {
        path: 'wareneingang/ohne-pruefung',
        name: 'wareneingangspruefung.wareneingang.ohne_pruefung',
        component: () => import('@/views/wareneingangspruefung/WareneingangListe.vue'),
        props: {
          title: 'Wareneingänge ohne Prüfung',
          ohneWep: true,
          wepColumnLabel: '',
        },
      },
      {
        name: 'wareneingangspruefung.id',
        path: ':id',
        component: () => import('@/views/wareneingangspruefung/Wareneingangspruefung.vue'),
        props: true,
      },
      {
        name: 'wareneingangspruefung.id.edit',
        path: ':id/edit',
        component: () => import('@/views/wareneingangspruefung/Wareneingangspruefung.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: true,
        }),
      },
      {
        path: 'admin',
        component: () => import('@/layouts/wareneingangspruefung/WareneingangspruefungAdmin.vue'),
        children: [
          {
            name: 'wareneingangspruefung.admin',
            path: 'list',
            component: () => import('@/views/wareneingangspruefung/admin/Wareneingangspruefungliste.vue'),
          },
          {
            name: 'wareneingangspruefung.admin.entwuerfe',
            path: 'list/entwuerfe',
            component: () => import('@/views/wareneingangspruefung/admin/Wareneingangspruefungliste.vue'),
            props: {
              title: 'Wareneingangsprüfung - Entwürfe',
              status: wareneingangspruefungStatus.entwurf,
            },
          },
          {
            path: 'wareneingangspruefung/neu',
            name: 'wareneingangspruefung.admin.neu',
            component: () => import('@/views/wareneingangspruefung/admin/Wareneingangspruefung.vue'),
            props: {
              id: null,
              edit: true,
            },
          },
          {
            path: 'wareneingangspruefung/:id',
            name: 'wareneingangspruefung.admin.id',
            component: () => import('@/views/wareneingangspruefung/admin/Wareneingangspruefung.vue'),
            props: true,
          },
          {
            path: 'wareneingangspruefung/:id/edit',
            name: 'wareneingangspruefung.admin.id.edit',
            component: () => import('@/views/wareneingangspruefung/admin/Wareneingangspruefung.vue'),
            props: (route) => ({
              edit: true,
              id: route.params.id,
            }),
          },
          {
            path: 'artikel/ohne_wep',
            name: 'wareneingangspruefung.artikel.ohne_wep',
            component: () => import('@/views/wareneingangspruefung/admin/ArtikelListeOhneWep.vue'),
            props: true,
          },
        ],
      },
    ],
  },
];
